module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dEzz2"))).then(() => module.bundle.root('f4eak'));